import { LOCALES } from "../locales";

export default {
  [LOCALES.FRENCH]: {
    // general product translation
    January: "janvier",
    February: "février",
    March: "mars",
    April: "avril",
    May: "mai",
    June: "juin",
    July: "juillet",
    August: "août",
    September: "septembre",
    October: "octobre",
    November: "novembre",
    December: "décembre",

    class_policy: "Règles du cours",
    Faq: "FAQs",
    help: "Aide",
    frequently_asked_ques: "Foire aux questions (FAQ)",
    customer_support: "Support client",
    user_name: "Identifiant ",
    password: "Mot de passe",
    email_address: "E-mail",
    // Header Translations
    notification: "Notification",
    page_loading_aria: "Chargement de la page en cours",
    state_loading_aria: "Chargement de l’état en cours",
    city_loading_aria: "Chargement de la ville en cours",
    badge_placeholder: "Badge placeholder",
    badge_overall: "Badge général",
    badge_demo_skills: "Badge placeholder for demo user, skills",
    badge_demo_be: "Badge placeholder for demo user, business english",
    certificate_placeholder: "Vue de l’Attestation",
    certificate_download: "Télécharger l’Attestation",
    prev: "Précédent",
    log_out: "Déconnexion",
    // feature names
    feature_progress: "Progression",
    feature_stressAndIntonation_title: "Accentuation et intonation",
    feature_soundOfEnglish_title: "Sons de l'anglais",
    feature_vocabularyCenter_title: "Vocabulaire",
    feature_grammarCenter_title: "Grammaire",
    feature_culture_centre_title: "Fiches Culturelles",
    feature_globalCommunityTutorials_title: "Global community tutorials",
    feature_industryfeed_title: "Actualités du secteur ",
    feature_newsfeed_title: "Actualités",
    feature_emailTemplates_title: "Modèles d’e-mails",
    feature_talkWithTeacher_title: "Talk with teacher",
    feature_accentsAndDialects_title: "Accents et codes culturels",
    feature_writingCenter_title: "Rédaction",
    feature_toeic_title: "TOEIC",
    feature_toefl_title: "TOEFL",
    // Footer translations
    about: "À propos",
    legal: "Mentions légales",
    privacy_policy: "Politique de confidentialité",
    Terms_conditions: "Conditions générales d'utilisation ",
    //button translations
    button_continue: "Poursuivre",
    button_KnowMore: "En savoir plus",
    button_BuyNow: "Acheter",
    button_Subscribe: "S'inscrire",
    button_GetStarted: "Commencer",
    button_view: "View",
    button_GoText: "Go",
    button_Resume: "Continue learning",
    button_ViewDetails: "Afficher les détails",
    button_ContinueStudying: "Continuer",
    button_next: "Suivant",
    button_confirm: "Valider",
    // cookie policy
    common_cookiesPolicyText1:
      "En continuant d'utiliser notre site, vous acceptez l'utilisation des cookies qui vous donneront des services personnalisés. En savoir plus sur",
    common_cookiesPolicyText2: "les cookies",
    // EO cookie policy
    //login-page-translations//
    login_welcome: "Bienvenue,",
    login_heloo: "Nous sommes ravis de vous retrouver",
    login_welcome_text: "C'est parti !",
    login_log_in: "Connexion",
    login_errorIncorrectCreds: "Identifiant ou mot de passe incorrect",
    login_errorContactAmin: "Votre compte n'est pas actif. Veuillez contacter votre administrateur.",
    login_errorSSOuser: "Veuillez vous connecter à partir du portail de formation de votre entreprise.",
    login_forgotPassword: "Mot de passe oublié ?",
    login_resetPasswordTitle: "Réinitialiser le mot de passe",
    login_resetSuccess: "Vous allez recevoir un lien de réinitialisation de votre mot de passe par e-mail.",
    login_resetFailure: "Adresse e-mail incorrecte",
    // common translations
    message_errorDefault: "Une erreur est survenue.",
    message_successUpdated: "Mise à jour réussie",
    message_unknownError: "Unknown error",
    message_unAuthorized: "Vous n’êtes pas autorisé",
    message_passwordUpdated: "Mise à jour du mot de passe réussie",
    message_profileUpdated: "Mise à jour du profil réussie",
    message_welcomeSubmitted: "Informations envoyées avec succès",
    message_samepasswordError:
      "Entrez un nouveau mot de passe. Il doit être différent de vos précédents mots de passe.",
    SAR: "Sélectionner une région",
    SAL: "Sélectionner un lieu",
    SAT: "Sélectionner un thème",
    link_readmore: "Plus",
    //--//
    profile_title: "Profil",
    profile_nameLabel: "Je m'appelle: ",
    profile_countryLabel: "Pays",
    profile_stateLabel: "Etat / Province / Région ",
    profile_cityLabel: "Ville",
    profile_emailLabel: "Courriel",
    profile_prefContactLabel: "Mode de communication préféré",
    profile_prefSkypeLabel: "Identifiant Skype (Personnel)",
    profile_prefMobileLabel: "Numéro de portable",
    profile_prefLandlineLabel: "Numéro de fixe",
    profile_agreeTerms1: " ",
    profile_agreeTerms2: "J'accepte et je consens aux conditions générales d'utilisation ",
    profile_continueAria: "Touche    „Suivant“",
    profile_TermsAria: "Accepter les conditions générales d'utilisation ",
    profile_stateTooltip: "Votre fuseau horaire nous aidera à planifier vos sessions en ligne.",
    profile_cityTooltip:
      "Si vous ne vivez pas dans une des villes mentionnées ici, merci de choisir la plus proche de vous.",
    profile_emailTooltip: "Vérifiez votre adresse e-mail",
    profile_prefTooltip:
      "Toutes vos sessions auront lieu dans la classe virtuelle, même si vous avez mentionné un autre moyen de communication lors des étapes préliminaires. Nous vous demandons vos préférences uniquement pour usage interne, afin d’améliorer en permanence votre expérience d’apprentissage.",
    profile_fnamePlaceholder: "Prénom",
    profile_lnamePlaceholder: "Nom de famille",
    profile_countryPlaceholder: "Sélectionner un pays",
    profile_prefContactSelect: "Sélectionner votre préférence",
    profile_statePlaceholder: "Sélectionner un pays ",
    profile_cityPlaceholder: "Sélectionner une ville",
    profile_emailInvalidMessage: "Adresse e-mail incorrecte",
    profile_prefContactPlaceholder: "Choisir votre préférence",
    profile_prefSkypePlaceholder: "Skype (personnel)",
    profile_emailVerifiedChip: "Vérifié",
    profile_emailVerifyChip: "Vérifier",
    profile_emailpopup_head: "Entrer le code de vérification",
    profile_emailpopup_codePlaceholder: "Code",
    profile_emailpopup_resendText: "Renvoyer le code",
    profile_emailpopup_resendMessage: "Vous n'avez pas reçu le code?",
    profile_invalidNumber: "Numéro invalide",
    profile_prefSkypeAria: "Identifiant Skype (personnel) principal",
    profile_prefMobileAria: "Contact principal - Mobile",
    profile_prefLandlineAria: "Contact principal - Fixe",
    profile_emailpopup_incorrectCode: "Code non valide",
    profile_editLabel: "Modifier le profil",
    profile_editAria: "Modifier",
    profile_mainPasswordPlaceholder: "Entrez votre mot de passe",
    profile_updateLabel: "Actualiser",
    profile_welcomeJumbotron: "Présentez-vous",
    profile_cancelLabel: "Annuler",
    noAccessl1: "Oups! Vous n'êtes pas autorisé(e) à consulter cette page.",
    noAccessl2: "Retourner à la",
    noAccessl2_1: "page d'accueil",
    noAccessl3: "Veuillez contacter votre Administrateur Learnship pour obtenir de l'aide.",
    profile_license_information: "License information",
    profile_license_message: "Votre licence expire le",
    profile_changepass_changepassHead: "Modifier le mot de passe",
    profile_changepass_currentpassword: "Mot de passe actuel",
    profile_changepass_currentpasswordPlaceholder: "Entrer votre mot de passe actuel",
    profile_changepass_newpassword: "Nouveau mot de passe",
    profile_changepass_newpasswordPlaceholder: "Entrer le nouveau mot de passe",
    profile_changepass_confirmnewpassword: "Confirmer le nouveau mot de passe",
    profile_passMustInclude: "Votre mot de passe doit inclure :",
    profile_passdontmatch: "Les mots de passe ne correspondent pas.",
    profile_incorrectPassword: "Mot de passe incorrect",
    profile_passwordSubmit_title: "Entrer un mot de passe",
    profile_changepass_conditionLength: "Entre 8 et 32 caractères",
    profile_changepass_conditionUppercase: "Au minimum une majuscule",
    profile_changepass_conditionLowercase: "Au minimum une miniscule",
    profile_changepass_conditionSpecialCharacters: "Au minimum un chiffre et un de ces symboles $!#&@?%*_",
    profile_translationLanguage: "Langue de traduction ",
    profile_translationLanguagePlaceholder: "Sélectionner une langue",
    profile_managerEmailPlaceholder: "E-mail du Manager",
    profile_managerEmailpopupPlaceholder: "Adresse email du gestionnaire",
    // Learner Home Page translations
    learnerhome_survey_header: "Nous voulons connaître votre avis!",
    learnerhome_survey_line1:
      "Votre entreprise souhaite connaître votre expérience en tant qu’utilisateur de nos services.",
    learnerhome_survey_line2: "Veuillez répondre à notre enquête",
    learnerhome_survey_line3: "Vos commentaires sont très importants pour nous",
    learnerhome_survey_button1: "Répondre à l‘enquête",
    learnerhome_survey_button2: "Passer l‘enquête",
    active_course: "Cours actif",
    admin_header: "Administration",
    admin_dashboard_header: "Dashboard",
    get_startedText: "Cliquer sur une formation ci-dessous pour commencer",
    product_solo_desc:
      "Learnship Solo, notre formation en e-learning, apporte tout ce dont vos apprenants ont besoin pour pratiquer et améliorer leurs compétences en langue des affaires, en toute autonomie.",
    product_conversationPractice_desc:
      "Les apprenants peuvent programmer des sessions individuelles avec un formateur, afin de poser des questions, de discuter d’une problématique particulière ou de participer à des mises en situation. Destiné aux apprenants expérimentés qui souhaitent perfectionner leurs compétences. ",
    product_sprint_businessSkills_desc:
      "Cette formation blended nouvelle génération aide les apprenants à développer de nouvelles compétences professionnelles - animation de présentations et de réunions, négociation et rédaction professionnelle - en un temps record.",
    product_sprint_levelsProgress_desc:
      "Notre formation blended nouvelle génération permet à vos collaborateurs d'améliorer leurs compétences en anglais, selon un cadre standardisé.",
    product_sprint_business_german_desc:
      "Notre formation blended nouvelle génération aide vos collaborateurs à améliorer rapidement leurs compétences en allemand, selon un cadre standardisé.",
    product_sprint_business_french_desc:
      "Notre formation blended nouvelle génération aide vos collaborateurs à améliorer rapidement leurs compétences en français, selon un cadre standardisé.",
    product_sprint_business_spanish_desc:
      "Notre formation blended nouvelle génération aide vos collaborateurs à améliorer rapidement leurs compétences en espagnol, selon un cadre standardisé.",
    product_evolve_relocationLanguage_desc:
      "Notre formation aux expatriés permet aux apprenants de développer une compréhension accrue de la langue et des subtilités sociales de leur pays d’accueil.",
    product_evolve_culturePowerSkills_desc:
      "Aidez vos collaborateurs à développer les compétences culturelles dont ils ont besoin pour évoluer à l’international au sein d’équipes virtuelles. ",
    product_evolve_cultureFocus_desc:
      "Formation interculturelle destinée aux professionnels qui souhaitent mieux comprendre les spécificités d’un pays ou d’une région particulière et sa culture de travail.",
    product_evolve_cultureChange_desc:
      "Notre formation interculturelle incontournable destinée aux expatriés offre aux professionnels une compréhension approfondie des codes et des comportements qu’ils doivent adopter pour vivre et travailler dans un nouveau cadre culturel.",
    product_elevate_businessSkills_desc:
      "Des modules de formation courts et standardisés destinés aux apprenants qui souhaitent améliorer des compétences professionnelles spécifiques, telles que l'animation de présentations, la négociation ou la gestion d'une équipe. Nous proposons également des cours spécialisés, axés sur la terminologie spécifique à chaque secteur. ",
    product_elevate_levelsProgress_desc:
      "Cette formation en langue des affaires assurée par un formateur aide les apprenants à développer leurs compétences écrites et orales, selon un cadre standardisé. ",
    product_coach_languageCoach_desc:
      "Communiquez clairement et avec confiance, que ce soit en Comité de Direction, quand vous écrivez des e-mails, que vous négociez, ou même à la machine à café. Nos solutions de coaching individuel en langue, adressées spécifiquement aux managers, vous aident à être à l’aise dans les situations professionnelles qui l’exigent. Développez vos compétences en communication verbale, écrite, personnelle et professionnelle.",
    product_coach_cultureCoach_desc:
      "Un programme de coaching individuel pour les managers faisant face à des problématiques spécifiques de communication interculturelle.",
    product_solo_business_english:
      "Un programme d'apprentissage à plusieurs niveaux avec des exercices en ligne attractifs pour développer vos connaissances et votre pratique de l'anglais commercial à votre propre rythme.",
    product_solo_business_german:
      "Un programme d'apprentissage à plusieurs niveaux avec des exercices en ligne attractifs pour développer vos connaissances et votre pratique de l'allemand commercial à votre propre rythme.",
    product_solo_business_french:
      "Un programme d'apprentissage à plusieurs niveaux avec des exercices en ligne attractifs pour développer vos connaissances et votre pratique du français des affaires à votre propre rythme.",
    product_solo_business_spanish:
      "Un programme d'apprentissage à plusieurs niveaux avec des exercices en ligne attractifs pour développer vos connaissances et votre pratique de l'espagnol des affaires à votre propre rythme.",
    product_lorem_desc: "Lorem Ipsum lorstatment , consect eturadips cingelioremp.",
    product_dashboard_desc:
      "Accédez à Dashboard, une interface intuitive qui permet aux administrateurs de suivre l'utilisation, analyser les progrès des apprenants, optimiser les programmes et évaluer le retour sur investissement.",
    product_elevate_desc:
      "Elevate Business English est notre formation linguistique en face-à-face en ligne pour les apprenants qui désirent améliorer leur maîtrise de l'anglais des affaires avec un formateur personnel.",
    product_reach_desc:
      "Enhance your learning journey with personalized micro-modules and side missions focusing on real-world business skills.",
    product_lorem_solo_desc:
      "Ce programme multimédia complet  aide vos collaborateurs à améliorer rapidement leurs compétences linguistiques en Anglais dans un cadre normalisé.",
    //feature translations
    feature_cultureCentre_desc:
      "Familiarisez-vous avec les cultures des régions qui vous intéressent sur un plan professionnel. ",
    feature_emailTemplates_desc:
      "Les modèles d'e-mails couvrent une grand nombre de sujets business. Sélectionner le modèle que vous souhaitez puis exportez-le directement vers votre boîte e-mail, où vous pourrez le personnaliser.",
    feature_newsFeed_desc:
      "Bienvenur dans notre hub unique d'actualités internationales ! Apprenez l'anglais à partir de contenus et de questions générés en direct par notre système Learnship. ",
    feature_talkWithTeacher_desc:
      "This is for learners who want to apply their new skills in conversation. Users can join a virtual group classroom to practice their chosen language and take part in Q&As with speaking speacialists.",
    feature_industryFeed_desc:
      "Les Actualités par Secteur associe une bibliothèque d'articles spécialisés et des exercices de langue générés par Intelligence Artificielle. Choisissez un article et un point de grammaire que vous souhaitez pratiquer.",
    feature_accentsAndDialects_desc:
      "Explorez la richesse de l'utilisation de l'anglais dans le monde grâce à notre bibliothèque d'échantillons vocaux régionaux.",
    feature_stressAndIntonation_desc:
      "Faites-vous mieux comprendre et soyez plus naturel quand vous parlez anglais, en apprenant comment accentuer et adapter le rythme et l'intonation. ",
    feature_soundOfEnglish_desc:
      "Améliorez vos compétences communicatives en améliorant votre prononciation en anglais. ",
    feature_vocabularyCenter_desc:
      "Sans grammaire, on ne peut pas bien communiquer. Sans vocabulaire, on ne peut pas communiquer du tout. - David Wilkins",
    feature_grammarCenter_desc:
      "Le Centre de Grammaire vous aidera à utiliser les bonnes structures grammaticales lorsque vous parlez et écrivez. Les sujets de grammaire incluent notamment la formation de la phrase, les propositions, les verbes et les formes verbales. ",
    feature_globalCommunityTutorials_desc:
      "Améliorez vos compétences en anglais grâce à une série de leçons développées par la communauté.",
    feature_toeic_desc:
      "Le test TOEIC® est l'outil le plus utilisé au monde par les entreprises multinationales pour évaluer le niveau d'anglais de leurs collabroateurs. Le TOEIC® s'appuie sur des contenus écrits authentiques et des dialogues pour évaluer les compétences en anglais.",
    feature_toefl_desc:
      "Le TOEFL®, le Test d'Anglais comme Langue Etrangère, est utilisé dans le monde entier pour l'évaluation du niveau d'anglais dans les universités et les grandes écoles, les organismes gouvernementaux, ou encore pour l'octroi de bourses d'études.",
    feature_businessSituations_desc:
      "L'Index des Situations Professionnelles vous aide à trouver facilement des activités qui vous permettent de vous concentrer sur les notions linguistiques dont vous avez besoin pour communiquer dans différentes situations professionnelles.",
    //carousel block translations
    title_feature: "Fonctionnalités",
    we_recommend: "Nous vous recommandons également",
    // session report translations
    SessionReport_sessionReport: "Rapport de session",
    SessionReport_sessionDetails: "Informations",
    SessionReport_teacherName: "Nom du formateur",
    SessionReport_sessionReview: "Revoir la session",
    SessionReport_sessionFeedback: "Commentaires sur la session",
    SessionReport_sessionMaterials_Assignments: "Supports de travail et devoirs",
    SessionReport_instructions: "Consignes",
    SessionReport_open: "Ouvrir",
    SessionReport_invalidSession_Message: "Désolé, il n'y a pas de rapport disponible pour cette session.",
    SessionReport_rateSession: "Evaluez votre session",
    SessionReport_handouts: "Handouts",
    SessionReport_coachName: "Comment s'est passée votre session avec",
    SessionRating_sessionDate: "Date de la session",
    SessionRating_sessionTime: "Heure de la session",
    SessionRating_sessionDuration: "Durée de la session",
    SessionRating_status: "Statut",
    SessionRating_rateYourExperience: "Evaluez votre expérience",
    SessionRating_whatWentWrong: "Quelque chose vous a déplu ?",
    SessionRating_content: "Contenu",
    SessionRating_technology: "Technologie",
    SessionRating_comment: "Laissez un commentaire",
    SessionRating_submit: "Envoyer",
    SessionRating_remindMeLater: "Me le rappeler plus tard",
    SessionRating_close: "Fermer",
    SessionRating_completed: "Terminée",
    sessionRating_sessionDetails_mins: "Minutes",

    myschedule_availability_abty_given: "Nous faisons tout notre possible pour vous trouver un formateur.",
    myschedule_schedule: "Mon Emploi du Temps",
    myschedule_availability_needAvl: "Nous avons besoin de vos disponibilités pour planifier votre session",
    myschedule_availability_abty_not_given: "Entrer / Modifier vos disponibilités",
    myschedule_statusCard_completed: "Sessions terminées",
    myschedule_statusCard_remaining: "Sessions restantes",
    myschedule_statusCard_scheduled: "Session(s) à programmer",
    myschedule_statusCard_lost: "Sessions Perdues (annulation tardive ou absence)",
    myschedule_recentUpcoming_courseName: "Désignation du cours",
    myschedule_next_session: "Session suivante",
    myschedule_session_topic: "Thème de la session",
    myschedule_sessionDetails_communication: "Communication",
    myschedule_sessionDetails_allSessions: "Toutes les sessions",
    myschedule_sessionDetails_upcomingSessions: "Session à venir",
    myschedule_sessionDetails_pastSessions: "Sessions passées",
    myschedule_sessionDetails_teacher_name: "Formateur",
    myschedule_sessionDetails_sessions: "Quantité",
    myschedule_sessionDetails_date: "Date",
    myschedule_sessionDetails_time: "Heure",
    myschedule_sessionDetails_durationText: "Durée",
    myschedule_sessionDetails_min: "Min.",
    myschedule_reschedule_Title: "Comment reprogrammer vos sessions",
    myschedule_reschedule_InstrBegin: "Comment planifier vos sessions avec votre formateur :",
    myschedule_reschedule_instr1a: "Vérifier les informations de votre session en haut de page",
    myschedule_reschedule_instr1b: "Vous y trouverez la date et l'heure de votre session.",
    myschedule_reschedule_instr2: "Les disponibilités de votre formateur sont affichées en vert",
    myschedule_reschedule_instr3:
      "Vous pourrez consulter les disponibilités de votre formateur. Les créneaux disponibles sont indiqués en vert. ",
    myschedule_reschedule_instr4: "Sélectionner un créneau pour reprogrammer",
    myschedule_reschedule_instr5: "Pour reprogrammer, cliquer sur la zone verte correspondant au créneau souhaité",
    myschedule_reschedule_next_instr1: "Aucun créneau compatible",
    myschedule_reschedule_next_instr2:
      "Bien qu'il soit préférable de ne pas annuler vos sessions, si aucune disponibilité de votre formateur ne vous convient, vous pouvez cliquer sur le bouton “Aucun créneau compatible” pour annuler votre session. Votre formateur reprogrammera la session annulée pour vous, ou un administrateur vous contactera.",
    myschedule_reschedule_next_instr3: "Changer de formateur",
    myschedule_reschedule_next_instr4a:
      "Pour changer de formateur pour une ou plusieurs sessions, veuillez utiliser notre",
    myschedule_reschedule_next_instr4b: "Formulaire de contact",
    myschedule_reschedule_next_instr4c:
      "et sélectionnez “Sprint” + “Changer de formateur”. Merci de préciser les raisons de votre demande.",
    myschedule_rechedule_next_info:
      "Pour plus d'informations concernant les reprogrammations et annulations de sessions, veuillez consulter notre",
    myschedule_rechedule_next_faq: "Foire aux questions (FAQ)",
    myschedule_rechedule_next_noShow: "Ne plus voir cette information",
    myschedule_rechedule_next_done: "Terminé",
    myschedule_rechedule_skipButton: "Passer",
    myschedule_upcoming_joinNow: "Rejoindre",
    myschedule_cancel_question: "Êtes-vous certain(e) de vouloir annuler cette session?",
    myschedule_cancel_button: "Annuler la session",
    myschedule_cancel_no: "Non",
    myschedule_invalid_session: "Désolé, cette session n'est pas valide",
    myschedule_sessionDuraion_minutes: "Minutes",
    myschedule_homepage_view: "Afficher",
    myschedule_finished_status: "Terminé",
    myschedule_reschedule_button: "Reprogrammer",
    myschedule_addToCalendar_instr1: "Cliquer sur le",
    myschedule_addToCalendar_instr2:
      "bouton de téléchargement pour obtenir votre programme Learnship. Vous pourrez ensuite l'ajouter à votre agenda personnel.",
    myschedule_addToCalendar_instr3:
      "Si vous avez déjà ajouté un programme Learnship à votre agenda, veillez bien à le supprimer auparavant.",
    myschedule_addToCalendar_instr4:
      "Pour en savoir plus sur comment ajouter un programme  Learnship à votre agenda personnel, cliquez",
    myschedule_addToCalendar_instr5: "ici",
    myschedule_no_teacher_title: "Enseignant non disponible",
    myschedule_no_teacher_body:
      "Aucune session ne peut être ajoutée pour le moment (Pas de professeur attribué). Veuillez contacter coach@globalenglish.com pour poursuivre votre programme.",
    myschedule_no_sessions: "Aucune session trouvée",
    myschedule_no_upcoming_sessions: "Aucune session à venir",
    myschedule_no_past_sessions: "Aucune session antérieure",
    myschedule_status_lost: "Perdu",
    myschedule_status_finished: "Terminé",
    myschedule_status_completed: "Terminé",
    myschedule_status_cancelled: "Annulé",
    myschedule_status_inprogress: "En cours",
    myschedule_status_pending: "En attente",
    myschedule_status_active: "Actif",
    myschedule_status_inplanning: "En cours de planification",

    // my schedule page translations end

    // Progress page
    progress_title: "Ma progression",
    progress_activity_report: "Rapport d'activités",
    progress_test_results: "Résultats du test",
    progress_productname_sprint_skills: "Sprint Business Skills",
    progress_productname_reach_skills: "Compétences Reach ",
    progress_skill_note:
      "Vous devez achever au moins 70% du travail et des sessions du cours pour pouvoir obtenir un certificat de réussite.",
    progress_overall_card_title_prework: "Exercices préparatoires terminés",
    progress_overall_card_title_homework: "Devoirs terminés",
    progress_overall_card_title_session: "Sessions terminées",
    progress_overall_card_title_certificate: "Certificat",
    progress_overall_card_title_skillsCompleted: "Compétences acquises",
    progress_overall_card_title_badgesEarned: "Badges remportés",
    progress_overall_card_title_missionsPassed: "Missions réussies",
    progress_overall_card_title_timeInReach: "Temps passé sur Reach (HH:MM)",
    progress_noSubskill: "Aucune sous-compétence disponible",
    progress_tab_nodata: "Aucune information disponible.",
    progress_percentCompleted: "degré d’avancement",
    progress_subskill_preworkTitle: "Travail préparatoire",
    progress_subskill_homeworkTitle: "Devoirs",
    progress_subskill_sessionTitle: "Session",
    progress_subskill_sessionStatusCompleted: "Terminée",
    progress_subskill_sessionStatusNotCompleted: "A compléter",
    progress_subskill_sessionStatusNoSessions: "Pas de sessions",
    progress_subskill_sessionNoDate: "N/A",
    progress_activity_tooltip_totaltime: "Durée totale",
    progress_activity_tooltip_activitiesCompleted: "Activités terminées",
    progress_activity_tooltip_reachMissionsCompleted: "Missions Reach réalisées",
    progress_activity_tooltip_timeinhhmm: "Heure HH:MM",
    progress_activity_tabDaily: "Par jour",
    progress_activity_tabWeekly: "Par semaine",
    progress_activity_tabMonthly: "Par mois",
    progress_activity_tabQuarterly: "Par trimestre",
    progress_activity_tabQuarter: "Trimestre",
    progress_activity_tabYearly: "Par an",
    progress_acitivity_Minutes: "Minutes",
    progress_acitivity_legend_selfpaced: "Durée de travail autonome ",
    progress_acitivity_legend_trainerLed: "Durée de travail avec formateur",
    progress_acitivity_legend_recommended: "Recommandation ",
    progress_testresults_table_testname: "Désignation du test",
    progress_testresults_table_scores: "Résultats",
    progress_testresults_table_date: "Date",
    progress_testresults_info: "Vos résultats seront disponibles dans 24 heures.",
    progress_inprogress: "En cours",
    progress_totalscore: "Note totale",
    progress_placedText: "Qualifié",
    progress_button_viewscore: "View detailed report",
    progress_certificate_download_success: "Downloaded successfully",
    progress_partText: "Partie",
    progress_emptyPartText: "Other",
    progress_overall_card_title_badge: "Badge",
    progress_badge_dialog_box_title:
      "Pour obtenir une Attestation de réussite, il est nécessaire d’avoir fait 70 % des exercices en ligne.",
    progress_badge_dialog_box_golden: "Un score de 80 % donne droit à un badge d'or.",
    progress_badge_dialog_box_silver: "Un score entre 70 % et 79 % donne droit à un badge d'argent.",
    progress_badge_dialog_box_bronze: "Un score entre 50 % et 69 % donne droit à un badge de bronze.",
    progerss_badge_dailog_box_digitalActivities:
      "Le score est calculé sur la base de vos performances et de votre assiduité dans les activités numériques en ligne.",
    progress_badge_dailog_box_liveSessions:
      "Le score est calculé sur la base de vos performances et de votre assiduité dans les activités numériques en ligne et les sessions en direct.",
    progress_elevate_dialog_box_liveSessions:
      "The success score is calculated based on your performance and engagement with live sessions",

    //EO Progress page
    //Email templates
    languageSelect: "Select a language",
    wcGroup1: "Excuses",
    wcGroup2: "Plaintes",
    wcGroup3: "Compliments",
    wcGroup4: "Félicitations",
    wcGroup5: "Documents",
    wcGroup6: "Invitations",
    wcGroup7: "Demandes d'emploi",
    wcGroup8: "Marketing et ventes",
    wcGroup9: "Réunions",
    wcGroup10: "Avis",
    wcGroup11: "Commandes",
    wcGroup12: "Informations tarifaires",
    wcGroup13: "Requêtes",
    wcGroup14: "Remerciements",
    wcTitle11: "Excuses pour le retard d'un projet",
    wcTitle12: "Excuses pour une erreur de comptabilité",
    wcTitle13: "Excuses pour un retard de livraison",
    wcTitle14: "Excuses pour la livraison de biens endommagés",
    wcTitle15: "Excuses pour une absence à une réunion",
    wcTitle21: "Plainte générale",
    wcTitle22: "Plainte portant sur un problème lié à un produit",
    wcTitle23: "Plainte portant sur la surfacturation d'un compte",
    wcTitle31: "Compliment à un collègue au sujet d'un projet",
    wcTitle32: "Compliment au sujet du service clientèle",
    wcTitle33: "Compliment au sujet d'un produit",
    wcTitle41: "Félicitations au sujet d'une promotion (formelles)",
    wcTitle42: "Félicitations au sujet d'une promotion (informelles)",
    wcTitle43: "Félicitations au sujet d'un événement personnel",
    wcTitle51: "Document demandé",
    wcTitle52: "Formulaire ou bon de commande",
    wcTitle53: "Facture",
    wcTitle61: "Invitation à un événement mondain",
    wcTitle62: "Invitation à un événement professionnel",
    wcTitle63: "Accepter une invitation",
    wcTitle64: "Refuser une invitation",
    wcTitle65: "Annuler un événement professionnel",
    wcTitle71: "Accusé de réception d'une demande",
    wcTitle81: "Annonce d'un nouveau produit",
    wcTitle82: "Annonce d'un nouveau représentant local",
    wcTitle83: "Démonstration d'un nouveau produit",
    wcTitle84: "Changement d'adresse de facturation",
    wcTitle85: "Suivi après une première réunion de vente",
    wcTitle86: "Souhaiter la bienvenue à un nouveau client",
    wcTitle87: "Message de vœux aux actionnaires ou aux clients",
    wcTitle91: "Proposer une heure pour une réunion",
    wcTitle92: "Confirmer une réunion",
    wcTitle93: "Ajourner une réunion",
    wcTitle94: "Annuler une réunion",
    wcTitle95: "Récapituler une réunion",
    wcTitle101: "Compte suspendu",
    wcTitle102: "Demande de fermeture d'un compte",
    wcTitle111: "Confirmer une commande",
    wcTitle112: "Fournir la confirmation d'une expédition",
    wcTitle113: "Annuler une commande",
    wcTitle114: "Modifier une commande",
    wcTitle115: "Accuser réception d'une livraison",
    wcTitle121: "Fournir des informations tarifaires",
    wcTitle122: "Accepter un devis",
    wcTitle123: "Refuser un devis",
    wcTitle131: "Demande d'éclaircissement d'informations",
    wcTitle132: "Demande d'informations sur un produit",
    wcTitle133: "Demande d'informations sur un service",
    wcTitle141: "Remerciements généraux",
    Blob:
      "Les modèles d'e-mails couvrent une large palette de sujets professionnels. Veuillez choisir le modèle que vous souhaitez utiliser, puis exportez-le directement vers votre messagerie pour le modifier.",
    OpenInEmail: "Ouvrir dans un e-mail  ",
    Quote1: "Il y a actuellement 3,3 milliards d'adresses électroniques dans le monde.",
    Quote1By: "Mashable",
    Quote2: "Les e-mails génèrent près de 2 fois plus de retours que les autres canaux.",
    Quote2By: "Piste de marketing direct",
    Quote3: "3,5 millions e-mails sont envoyés par seconde.",
    Quote3By: "Piste marketing",
    SelectACategory: "Sélectionner une catégorie",
    Title: "Modèles d'e-mails",
    WatchTutorial: "Regarder une vidéo d'explication",
    String: "Quote1",
    //Culture Notes Dropdowns
    NoAm: "Amérique du Nord",
    Cenam: "Amérique Centrale",
    SoAm: "Amérique du Sud",
    EUR: "Europe",
    ASIA: "Asie",
    CenASIA: "Asie Centrale",
    SoEASIA: "Asie du Sud-Est",
    MidEAST: "Moyen-Orient",
    AFR: "Afrique",
    AUST: "Australie",
    Cana: "Canada",
    Mexi: "Mexique",
    Uniteds: "Etats-Unis",
    CostaR: "Costa Rica",
    DomRep: "République Dominicaine",
    Guate: "Guatemala",
    Jama: "Jamaïque",
    Panam: "Panama",
    TriniTob: "Trinité-et-Tobago",
    Arge: "Argentine",
    Braz: "Brésil",
    Chil: "Chili",
    Vene: "Vénézuela",
    Colomb: "Colombie",
    Peru: "Pérou",
    Urug: "Uruguay",
    Austria: "Autriche",
    Belg: "Belgique",
    Bulg: "Bulgarie",
    Croatia: "Croatie",
    Czec: "République Tchèque",
    Denm: "Danemark",
    Finl: "Finlande",
    Fran: "France",
    Germ: "Allemagne",
    Greec: "Grèce",
    Hung: "Hongrie",
    Icel: "Islande",
    Irel: "Irlande",
    Ital: "Italie",
    Lith: "Littuanie",
    Luxem: "Luxembourg",
    Neth: "Pays-Bas",
    Norw: "Norvège",
    Pola: "Pologne",
    Port: "Portugal",
    Roma: "Roumanie",
    Russ: "Féderation de Russie",
    Serb: "Serbie",
    Slovakia: "Slovaquie",
    Slovania: "Slovénie",
    Spai: "Espagne",
    Swed: "Suède",
    Swit: "Suisse",
    Turk: "Turquie",
    Ukra: "Ukraine",
    Unitedk: "Royaume-Uni",
    Chin: "Chine",
    Hong: "Hong Kong",
    Indi: "Inde",
    Japa: "Japon",
    Mongo: "Mongolie",
    Pakis: "Pakistan",
    SoKore: "Corée du Sud",
    SriLan: "Sri Lanka",
    Taiw: "Taïwan",
    Afgh: "Afghanistan",
    Azer: "Azerbaijan",
    Kaza: "Kazakhstan",
    Camb: "Cambodge",
    Indo: "Indonésie",
    Malay: "Malaisie",
    Phil: "Philippines",
    Sing: "Singapour",
    Thai: "Thaïlande",
    Viet: "Vietnam",
    Bah: "Barheïn",
    Iran: "Iran",
    Iraq: "Irak",
    Isra: "Israël",
    Jor: "Jordanie",
    Kuw: "Koweït",
    Leb: "Liban",
    Oma: "Oman",
    Qat: "Qatar",
    SauArb: "Arabie Saoudite",
    UAE: "Emirats Arabes Unis",
    Alger: "Algérie",
    Angol: "Angola",
    Egyp: "Egypte",
    Ghana: "Ghana",
    Guin: "Guinée",
    Keny: "Kenya",
    Malaw: "Malawi",
    Moroc: "Maroc",
    Mozam: "Mozambique",
    Nige: "Nigeria",
    SoAfr: "Afrique du Sud",
    Tanz: "Tanzanie",
    Ugan: "Ouganda",
    Zamb: "Zambie",
    Austra: "Australie",
    NewZea: "Nouvelle-Zélande",
    //Culture Notes Dropdowns End
    culturenotes_mainintrotext:
      "Familiarisez-vous avec la culture des régions qui vous intéressent sur un plan professionnel.",
    culturenotes_useculturalinfo:
      "Utilisez nos présentations culturelles pour préparer vos réunions importantes avec des clients et des collaborateurs du monde entier.",
    culturenotes_topicfamiliarize:
      "Familiarisez-vous avec les codes propres à d'autres cultures, notamment les horaires de bureau, les sorties au restaurant, les cadeaux, etc.",
    culturenotes_topiclearnculture:
      "Découvrez les habitudes et les différences culturelles, ainsi que les comportements propres à chaque pays, pour éviter tout impair d'ordre culturel.",
    culturenotes_tmaworldtext:
      "Les fiches pays sont conçues par notre partenaire TMA World et sont téléchargeables au format PDF.",
    culturenoteslocation_viewbytopic: "Afficher par thème",
    culturenoteslocation_viewbycountry: "Afficher par pays",
    culurecenter_disclaimer_title: "Avertissement",
    culturecenter_disclaimer:
      "Merci de noter que ces informations constituent un guide général qui vous permet de commencer à vous familiariser à une nouvelle culture. Grâce à cet outil, vous pourrez en apprendre plus sur certains schémas culturels courants, qui vous serviront de cadre pour mieux comprendre et interpréter les différences culturelles en termes de comportements, d’attitudes et de réactions. Il est néanmoins important de garder à l’esprit que les caractéristiques relatives à une culture particulière varient d’une région à une autre et selon la personnalité de chacun.",
    culturecenter_intercept_title: "Les Fiches Culturelles sont de retour !​​",
    culturecenter_intercept_text1:
      "Après un léger rafraîchissement, nous sommes heureux de vous annoncer le retour des Fiches Culturelles !",
    culturecenter_intercept_text2:
      "Avec les Fiches Culturelles, vous avez l’opportunité d’en apprendre plus sur les pratiques professionnelles et les coutumes de 20 pays dans le monde, notamment les États-Unis, le Canada, le Mexique, la Chine, le Japon, l’Inde, et bien plus…",
    culturecenter_intercept_direct: "Consulter les Fiches Culturelles",
    dailyNewsFeed_resources: "Ressources",
    dailyNewsFeed_daily_News: "Daily News Feed",
    dailyNewsFeed_newsfeedoftheday: "Fil d’actualité journalier",
    dailyNewsFeed_feedcontent:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut auctor orci at quam porta dictum. Duis id vestibulum dui. Phasellus interdum augue magna, in tempus velit imperdiet id.",
    dailyNewsFeed_noData:
      "Désolé, nous n'avons pas pu récupérer les nouvelles du jour, veuillez réessayer ultérieurement",
    dailyNewsFeed_viewMoreCategories: "Voir plus",
    // Email templates end
    //Error Page Translations
    error_not_found: "Oops! Page non trouvée.",
    error_contact_csm: "Veuillez contacter le service clientèle pour obtenir de l'aide.",
    error_under: "Sous",
    error_maintenance: "miantenance",
    error_under_maintenance: "Notre site est actuellement en cours de maintenance",
    error_inconvenience: "Nous vous prions de nous excuser pour ce désagrément",
    error_tryagain: "Veuillez réessayer plus tard",
    error_tryagainMins: "Veuillez réessayer dans",
    error_minutes: "minutes(s)",
    error_hours: "heure(s)",
    error_oops: "Oops!",
    error_permission_denied: "Vous n’êtes pas autorisé à consulter cette page!",
    error_link_home: "page d’accueil",
    error_contact_admin:
      "Veuillez contacter votre administrateur <donottrans> Learnship </donottrans> pour obtenir de l'aide.",
    error_sorry: "Désolés",
    error_load: "There was a problem loading this Page.",
    error_clear_cache: "Veuillez vider le cache de votre navigateur, vérifier votre connexion Internet et réessayer. ",
    error_contact: "Veuillez contacter notre",
    error_contact_cst: "Équipe d’assistance à la clientèle",
    error_forhelp: "Pour obtenir de l’aide",
    error_having_trouble: "Vous avez encore des difficultés?",
    //Accents and Dialects Dropdowns
    AF: "Afrique",
    AS: "Asie",
    AU: "Australie-Océanie",
    CA: "Caraïbes",
    CE: "Amérique centrale",
    EU: "Europe",
    MI: "Moyen-Orient",
    NO: "Amérique du Nord",
    SO: "Amérique du Sud",
    CAMER: "Cameroun",
    EGYPT: "Égypte",
    ETHIO: "Éthiopie",
    GHANA: "Ghana",
    GUINE: "Guinée",
    NIGER: "Nigeria",
    SOUTH: "Afrique du Sud",
    TANZA: "Tanzanie",
    AFGHA: "Afghanistan",
    CHINA: "Chine",
    INDIA: "Inde",
    INDON: "Indonisie",
    JAPAN: "Japon",
    KAZAK: "Kazakhstan",
    LEBAN: "Liban",
    MONGO: "Mongolie",
    NORTH: "Nord-Vietnam",
    PAKIS: "Pakistan",
    PHILI: "Philippines",
    SINGA: "Singapour",
    KOREA: "Corée",
    SRI_L: "Sri Lanka",
    TAIWA: "Taïwan",
    THAIL: "Thaïlande",
    TURKM: "Turkministan",
    AUSTR: "Australie",
    FIJI_: "Fidji",
    NEW_Z: "Nouvelle-Zilande",
    BERMU: "Bermudes",
    CUBA_: "Cuba",
    HAITI: "Haoti",
    COSTA: "Costa Rica",
    GUATE: "Guatemala",
    MARTI: "Martinique (France)",
    TRINI: "Trinité-et-Tobago",
    AUSTRI: "Autriche",
    BELAR: "Biélorussie",
    BELGI: "Belgique",
    BULGA: "Bulgarie",
    CYPRU: "Chypre",
    CZECH: "République Tchèque",
    DENMA: "Danemark",
    ENGLA: "Angleterre",
    FINLA: "Finlande",
    FRANC: "France",
    GEORG: "Géorgie",
    GERMA: "Allemagne",
    GREEC: "Grèce",
    HUNGA: "Hongrie",
    IRELA: "Irlande",
    ITALY: "Italie",
    MACED: "Macédoine du Nord",
    NETHE: "Pays-Bas",
    NORTHI: "Irlande du Nord",
    POLAN: "Pologne",
    ROMAN: "Roumanie",
    RUSSI: "Féderation de Russie",
    SCOTL: "Écosse",
    SPAIN: "Espagne",
    SWEDE: "Suède",
    SWITZ: "Suisse",
    TURKE: "Turquie",
    UKRAI: "Ukraine",
    WALES: "Pays de Galles",
    IRAN_: "Iran",
    IRAQ_: "Irak",
    ISRAE: "Israël",
    KUWAI: "Koweot",
    SAUDI: "Arabie saoudite",
    SYRIA: "Syrie",
    CANAD: "Canada",
    MEXIC: "Mexique",
    ARGEN: "Argentine",
    BRAZI: "Brésil",
    CHILE: "Chili",
    COLOM: "Colombie",
    PARAG: "Paraguay",
    PERU_: "Pirou",
    VENEZ: "Venezuela",
    RPTitle: "Rainbow passage",
    CGACTitle: "Comma Gets a Cure",
    accentsAndDialects_heading: "Accents et codes culturels",
    US: "États-Unis d'Amérique",
    ALABA: "Alabama",
    ALASK: "Alaska",
    ARKAN: "Arkansas",
    CALIF: "Californie",
    FLORI: "Floride",
    GEORG_US: "Géorgie",
    HAWAI: "Hawaii",
    ILLIN: "Illinois",
    INDIA_US: "Indiana",
    KANSA: "Kansas",
    KENTU: "Kentucky",
    LOUIS: "Louisiane",
    MAINE: "Maine",
    MARYL: "Maryland",
    MASSA: "Massachusetts",
    MICHI: "Michigan",
    MINNE: "Minnesota",
    MISSI: "Mississippi",
    MISSO: "Missouri",
    MONTA: "Montana",
    NEBRA: "Nebraska",
    NEW_H: "New Hampshire",
    NEW_J: "New Jersey",
    NEW_Y: "New York",
    NCARO: "Caroline du Nord",
    NDAKO: "Dakota du Nord",
    OHIO_: "Ohio",
    OKLAH: "Oklahoma",
    PENNS: "Pennsylvanie",
    SOUTH_US: "Caroline du Sud",
    TENNE: "Tennessee",
    TEXAS: "Texas",
    VIRGI: "Virginie",
    WEST_: "Virginie-Occidentale",
    WISCO: "Wisconsin",
    //Accents and Dialects Dropdowns End
    manager_email_managertext:
      "Votre entreprise a demandé un rapport mensuel pour votre responsable indiquant vos progrès chez Learnship. Veuillez indiquer ci-dessous l'adresse e-mail de votre responsable.",
    // survey and notification
    notification_description_plural:
      "{days} jours restants pour compléter le questionnaire. Vous devez le compléter avant le {date}.",
    notification_description_singular:
      "1 jour restant pour compléter le questionnaire. Vous devez le compléter avant le {date}.",
    notification_maintenance_message:
      "Une opération de maintenance de notre plateforme Halo aura lieu le {date} à {time}.",
    //renewal
    renewal_welcome: "Bienvenue sur Learnship",
    renewal_text:
      "Votre licence Learnship expirera le {date}, {month} {year}. Pour continuer à améliorer vos compétences en anglais professionnel, reconduisez votre licence dès aujourd'hui. Votre programme d'étude et l'ensemble de votre travail seront enregistrés et vous reprendrez au niveau actuel.",
    renewal_later: "Me recontacter ultérieurement.",
    renewal_affirmative: "Je souhaite reconduire ma licence.",
    renewal_negative: "Je ne souhaite pas reconduire ma licence.",
    renewal_yes: "OUI",
    renewal_no: "NON",
    courselevel: "Niveau du cours",
    currentunit: "Unité en cours",
    upcomingsession: "A venir",
    viewschedule: "View Schedule",
    currentskills: "Compétences",
    currentsubskills: "Sous-Compétences",

    // TWT translations
    twt_talk_with_teacher_title: "Parlez avec un professeur",
    twt_sub_heading:
      "Améliorez vos compétences à l'oral avec un professeur et d'autres étudiants dans notre salle de classe en ligne !",
    twt_select_sessions: "Sélectionnez vos sessions:",
    twt_view_schedule_title: "Voir les horaires et ajouter au calendrier",
    twt_next_week: "Semaine suivante",
    twt_previous_week: "Semaine précédente",
    twt_add_to_calendar: "Ajouter au calendrier",
    twt_view_more: "Afficher plus",
    twt_topic: "Sujet",
    twt_class_policy_title: "Politiques et directives pour Parlez avec un professeur",
    twt_class_policy_subHeading:
      "Les normes et directives suivantes sont importantes pour garantir que votre expérience avec Parlez avec un Professeur (TWT) soit éducative et agréable. Veuillez les lire attentivement.",
    twt_class_policy_list01: `Vous pouvez assister à une session par semaine *. Nos salles de classe en ligne ont une limite de huit apprenants. Meilleure pratique : Arrivez vers le début de la session. Les salles de classe TWT ne sont accessibles que pendant les 10 premières minutes de chaque session. Par exemple, une session qui commence à 9h00 est accessible jusqu'à 9h10. Après les 10 premières minutes, vous ne pourrez plus participer à la session. L'accès limité ou illimité dépend du type de licence dont vous disposez.`,
    twt_class_policy_list02_sub1:
      "Lorsque vous entrez dans la classe, tapez votre nom, votre ville, votre pays et votre niveau dans la zone de conversation.",
    twt_class_policy_list02_sub2: `Par exemple "My name is Leo, and I'm from Sao Paulo, Brazil. I'm in Level 6."`,
    twt_class_policy_list02_sub3: "L'instructeur activera alors votre microphone et l'icône du microphone apparaîtra.",
    twt_class_policy_list03:
      "Si vous rencontrez un problème technique, contactez le Support client. Cliquez sur Aide en haut de n'importe quelle page pour soumettre le problème par écrit ou parlez à un représentant du service clientèle grâce à l'outil de Chat q¬¬ue vous trouverez sur n'importe quelle page de Learnship One. Les incidences techniques ne sauraient être abordées avec le professeur.",
    twt_class_policy_list04:
      "Il existe quatre niveaux de session TWT: Débutant, Intermédiaire, Avancé et Tous Niveaux. Vous devez participer à des sessions adaptées à votre niveau d’anglais. Par exemple, si vous êtes dans un niveau compris entre 0 et 3, vous devez vous connecter à une session pour Débutant. Tout apprenant (quel que soit le niveau) peut assister aux sessions All Levels (Tous Niveaux). Si vous participez à une session TWT qui ne convient pas à votre niveau d’anglais, votre instructeur vous informera que vous ne vous trouvez pas dans la bonne session. Deux options s’offrent alors à vous : vous pouvez dire à l’instructeur que vous souhaitez rester et écouter uniquement, cela signifie que vous ne pourrez pas participer (parler) ; ou alors vous pouvez vous déconnecter et rejoindre à un autre moment une session qui soit de votre niveau.",
    twt_class_policy_list05:
      "Si vous souhaitez être présent(e) à une session en ligne sans parler, vous pouvez le faire au maximum quatre fois par an. Si vous dépassez cette limite et ne participez toujours pas oralement à la session, votre session prendra fin.",
    twt_class_policy_list06:
      "Nous ne tolérerons aucun langage obscène ou offensant, en anglais ou dans toute autre langue. Si vous enfreignez cette politique, nous vous retirerons immédiatement de la session. Aussi nous informerons votre responsable de votre comportement désobligeant et nous pourrions mettre fin à votre compte.",
    twt_class_policy_ok: "Ok",
    twt_max_multi_window_error_message:
      "You have already joined this session from another device. Please logout before joining from current device.",
    twt_max_capacity_error_message:
      "Sorry you cannot join this session because it has reached maximum capacity. Please join another session",
    twt_notification_message: "There's a conversation session starting right now. Do you want to join?",
    twt_limit_message: "Vous avez déjà assisté à un cours cette semaine.",
    twt_session_unavailable: "No sessions available",
    twt_select_language: "Select language",

    //Vocabulary center translations
    vocab_center_product_headline: "Vocabulary center",
    vocab_center_search_word: "Search and add word",
    vocab_center_add_wordlist: "Add Word List",
    vocab_center_edit_wordlist: "Edit Word List",
    vocab_center_delete_wordlist: "Delete Word List",
    vocab_center_options_text: "Options",
    vocab_center_add_word: "Add Word",
    vocab_center_add_text: "Add",
    vocab_center_delete_wordlist_warning_message: "All the words under the list will be deleted. Click Yes to delete.",
    vocab_center_yes_text: "Yes",
    vocab_center_new_wordlist: "New Word List",
    vocab_center_created_wordlist_success_message: "You have successfully created your new word list",
    vocab_center_updated_wordlist_success_message: "You have successfully updated your word list",
    vocab_center_okay_text: "Okay",
    vocab_center_new_word_text: "New Word",
    vocab_center_enter_word_text: "Enter a word",
    vocab_center_word_exists_in_wordlist_warning_message: "This word already exists in this Word List",
    vocab_center_save_text: "Save",
    vocab_center_new_word_message: "This word does not exist. Do you want to create your own definition for the word ?",
    vocab_center_pos_label: "Part of speech",
    vocab_center_select_wordlist_text: "Select a word list",
    vocab_center_word_label: "Word",
    vocab_center_update_wordlist: "Update word list",
    vocab_center_definition_label: "Definition",
    vocab_center_translation_label: "Translation",
    vocab_center_sentence_label: "Sentence",
    vocab_center_note_label: "Note",
    vocab_center_cancel_text: "Cancel",
    vocab_center_delete_word_text: "Delete Word",
    vocab_center_delete_word_warning_message: "Are you sure you want to delete this word from the Word List ?",
    vocab_center_note_updated_message: "Your notes updated successfully!!",
    vocab_center_close_text: "Close",
    vocab_center_no_definition_text: "No definition available",
    vocab_center_no_translation_text: "No translation available",
    vocab_center_no_sentence_text: "No sentence available",
    vocab_center_no_note_text: "No notes added",
    vocab_center_word_save_message: "You have successfully saved the word in your word List",
    vocab_center_word_exists_error_message: "Selected word already exists in the same wordlist",
    vocab_center_submit_text: "Submit",
    vocab_center_delete_text: "Delete",
    vocab_center_edit_text: "Edit",
    vocab_center_no_word_message: "Oops! There are no words in your wordlist. Add new words!",
    vocab_center_no_wordlist_message: "Oops! There are no wordslist in {wordListName}. Add new wordslist!",
    vocab_center_enter_wordlist_text: "Enter a word list",
    vocab_center_feature_text:
      "Without grammar, Very little can be conveyed. Without vocabulary, nothing can be conveyed. - David Wilkins",

    // Stress and inotation translations
    stress_intonation_product_headline: "StressAndIntonation",
    stress_intonation_product_description:
      "Make your English more natural and easier to understand by learning how to use correct stress, rhythm, and intonation when you speak.",

    // Sounds of English translations
    soe_product_headline: "Sounds of English",
    soe_product_description: "Improve your communication skills by learning how to pronounce English sounds correctly.",
    soe_product_vowels: "Vowels",
    soe_product_consonants: "Consonants",
    soe_product_language_selection:
      "Select your language in the drop-down list to find the sounds that may be difficult for speakers of your language. Then select My Sounds to find the sounds that you had trouble with in the Pronunciation Practice and Communication Practice activities.",

    // Writing center
    wc_feature_headline: "Centre d'expression écrite",
    wc_feature_description: "Level up your professional writing ability via our targeted resources.",
    wc_feature_guideGroup1: "Problèmes d'écriture courants",
    wc_feature_guideGroup2: "Communications professionnelles générales",
    wc_feature_guideGroup3: "Documents professionnels",
    wc_feature_guideTitle11: "Causes du manque de clarté dans l'écriture",
    wc_feature_guideTitle12: "Erreurs rédactionnelles élémentaires",
    wc_feature_guideTitle13: "Problèmes liés aux verbes",
    wc_feature_guideTitle21: "Franc-parler dans les communications professionnelles",
    wc_feature_guideTitle22: "Langage des ventes et du marketing",
    wc_feature_guideTitle23: "Idiomes courants dans le monde des affaires",
    wc_feature_guideTitle31: "E-mails efficaces",
    wc_feature_guideTitle32: "Présentations : Conseils généraux",
    wc_feature_guideTitle33: "Présentations : Introductions efficaces",
  },
};
